import { usePathname } from 'next/navigation'

export const useIsSimulationActive = () => {
  const pathname = usePathname()

  const isSimulationActive = pathname.startsWith('/dashboard/simulation')

  return isSimulationActive
}
